import { Fragment, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import Layout from "./Layout";
import Index from "./AccountWeb/Index";

const VALID_TABS = new Set([
  "account",
  "deposit",
  "withdraw",
  "betting",
  "accountRecord",
  "profitLoss",
  "rewardCenter",
  "invite",
  "mission",
  "internal",
  "rebate",
  "vip",
]);

export default function ReferenceMemberPage() {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setAccountModal = useContextSelector(AuthContext, (ctx) => ctx.setAccountModal);
  const setLoginModal = useContextSelector(AuthContext, (ctx) => ctx.setLoginModal);
  const setRegisterModal = useContextSelector(AuthContext, (ctx) => ctx.setRegisterModal);
  const [params] = useSearchParams();
  const tabParam = params.get("tab") || "account";
  const tab = VALID_TABS.has(tabParam) ? tabParam : "account";
  const loggedIn = Boolean(user?.user || user?.username);
  const mobileMember = isMobile && loggedIn;
  const MemberFrame = mobileMember ? "div" : Fragment;

  useEffect(() => {
    if (loggedIn) setAccountModal({ type: tab, status: true });
  }, [loggedIn, tab, setAccountModal, setLoginModal]);

  useEffect(
    () => () => setAccountModal({ type: "", status: false }),
    [setAccountModal]
  );

  return (
    <MemberFrame {...(mobileMember ? { className: "chorki-mobile-member-layout" } : {})}>
    <Layout>
      <main className="ref-member-page br_main">
        {loggedIn ? <Index embedded /> : (
          <section className="reference-account-signin" aria-labelledby="account-signin-title">
            <img src="/assets/Icon/0.webp" alt="" />
            <h1 id="account-signin-title">Your account</h1>
            <p>Sign in to manage your wallet, rewards, and account activity.</p>
            <button type="button" onClick={() => setLoginModal(true)}>Sign in</button>
            <button type="button" className="account-register" onClick={() => setRegisterModal(true)}>Create an account</button>
            <ul>{["Deposit & withdrawal", "Betting & transaction records", "Rewards & missions", "Invite friends", "Internal messages", "Manual rebate"].map(label => <li key={label}>{label}</li>)}</ul>
          </section>
        )}
      </main>
    </Layout>
    </MemberFrame>
  );
}
